import React, { useState, useEffect } from 'react';
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarQuickFilter
} from '@mui/x-data-grid';
import DatabaseService from '../../services/database.service.js';
import EventBus from '../../common/EventBus';
import AuthService from "../../services/auth.service";
import gridSxStyle from "../../common/GridSxStyles.js";
import { ToastContainer, toast } from 'react-toastify';
import { getBootstrapColors } from '../race/RaceColors.js';

const TagsTrackingGrid = ({ onSelectDevice }) => {
    const [devices, setDevices] = useState([]);
    const [selectedDevice, setSelectedDevice] = useState(null);


    const currentUser = AuthService.getCurrentUser();
    const isAdmin = currentUser.roles.includes("admin_smart");
    const isPartner = currentUser.roles.includes("partner");

    const DEFAULT_SORT_MODEL = [{ field: 'date_app_cnx', sort: 'desc' }];
    const storedSortModel = localStorage.getItem('tagsTrackingSortModel');
    const initialSortModel = storedSortModel ? JSON.parse(storedSortModel) : DEFAULT_SORT_MODEL;
    const [tagsTrackingSortModel, settagsTrackingSortModel] = useState(initialSortModel);

    const DEFAULT_PAGINATION_MODEL = { page: 0, pageSize: 45 };
    const storedPaginationModel = localStorage.getItem('tagsTrackingPaginationModel');
    const initialPaginationModel = storedPaginationModel ? JSON.parse(storedPaginationModel) : DEFAULT_PAGINATION_MODEL;
    const [tagsTrackingPaginationModel, settagsTrackingPaginationModel] = useState(initialPaginationModel);

    const columns = [
        {
            field: 'actions', headerName: '',
            width: 20,
            resizable: false,
            renderCell: ({ row }) => (
                <div style={{ textAlign: 'center' }}>
                    <i className="fa fa-solid fa-location-crosshairs"
                        style={{
                            padding: "5px",
                            color: row.id === selectedDevice ? getBootstrapColors()[0] : "",
                            width: 20,
                        }}
                        onClick={() => {
                            handleSelectDevice(row)
                        }}
                    />
                </div>
            )
        },
{
    field: 'ble_name', headerName: 'Smart Name',
        width: 100,
        },
{
    field: 'user_id', headerName: 'Email',
        width: 250,
        }
    ];

const handleSelectDevice = (row) => {
    try {
        if (!row || !row.id) {
            console.error('Invalid row object in handleSelectDevice:', row);
            return;
        }
        
        if (onSelectDevice) {
            setSelectedDevice(row.id);
            onSelectDevice(row);
        }
    } catch (error) {
        console.error('Error in handleSelectDevice:', error);
    }
};

const handleSortModelChange = (sortModel) => {
    settagsTrackingSortModel(sortModel);
    localStorage.setItem('tagsTrackingSortModel', JSON.stringify(sortModel));
};

const handlePaginationModelChange = (paginationModel) => {
    settagsTrackingPaginationModel(paginationModel);
    localStorage.setItem('tagsTrackingPaginationModel', JSON.stringify(paginationModel));
};

const showToast = () => {
    toastId = toast.loading("Refreshing", {
        position: "bottom-right",
        autoClose: false, // Prevent auto-close to manually control the duration
    });
};

let toastId = null;
let minToastDuration = 1500; // Minimum toast display time in milliseconds

const loadDevices = () => {
    const startTime = Date.now();

    DatabaseService.getDevicesWithTags().then(
        (response) => {
            // filter response.data to only include devices with tag_keys
            const responseFiltered = response.data.filter((device) => device.tag_keys != null);

            setDevices(responseFiltered);

            const loadDuration = Date.now() - startTime;
            const displayDuration = Math.max(minToastDuration, loadDuration);

            setTimeout(() => {
                toast.dismiss(toastId);
            }, displayDuration);

            console.log("response.data", JSON.stringify(response.data[0]));
        },
        (error) => {
            if (error.response && error.response.status === 401) {
                EventBus.dispatch("logout");
            }
        }
    );
};

useEffect(() => {
    loadDevices();
}, []);

const TableToolbar = (props) => {
    return (
        <GridToolbarContainer>

            <button className="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeSmall MuiButton-textSizeSmall MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeSmall MuiButton-textSizeSmall MuiCustomButton"
                onClick={() => {

                    showToast();
                    loadDevices();

                }}>
                <i className="fa-solid fa-arrows-rotate" style={{ color: 'var(--color-foreground)', marginRight: '8px' }}></i>
                Refresh
            </button>

            <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            <GridToolbarExport />
            <GridToolbarQuickFilter />
        </GridToolbarContainer>
    );
};

return (
    <>
        <ToastContainer />
        <DataGrid
            getRowId={(row) => { return row.id ? row.id : "unused" }}
            columnHeaderHeight={35}
            rowHeight={30}
            rows={devices}
            columns={columns}
            initialState={{
                sorting: { sortModel: tagsTrackingSortModel },
                pagination: { paginationModel: tagsTrackingPaginationModel },
                columns: {
                    columnVisibilityModel: {
                        "comment": isAdmin,
                    },
                },
            }}
            onSortModelChange={handleSortModelChange}
            disableVirtualization
            disableRowSelectionOnClick
            disableDensitySelector
            pageSizeOptions={[25, 30, 35, 40, 45, 50, 55, 60, 100]}
            onPaginationModelChange={handlePaginationModelChange}
            slots={{ toolbar: TableToolbar }}
            slotProps={{
                toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                },
            }}
            sx={gridSxStyle}
        />
    </>
);
};

export default React.memo(TagsTrackingGrid);
